export default __webpack_public_path__ + "static/media/BociniCover2017-400x482.21db210e.jpg";